var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var JSONLd = function (_a) {
    var data = _a.data, type = _a.type;
    var finalData = __assign({ "@context": "http://schema.org", "@type": type }, data);
    return _jsx("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(finalData) } });
};
export default JSONLd;
